import { FC, SVGProps } from 'react';

const BroadcastIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M9.04392 12.47V12.4781M4.3122 11.288C6.18197 11.6212 9.07175 12.3088 12.2697 13.6864C13.6124 14.2646 15.1116 13.3077 15.1133 11.8458L15.1213 5.62521C15.1246 3.38408 13.627 2.42487 12.2818 3.00057C9.07825 4.37005 6.1844 5.05114 4.31383 5.37872C3.10489 5.59034 2.50244 6.64522 2.50082 7.87282L2.5 8.78825C2.49839 10.0182 3.10083 11.0723 4.3122 11.288Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1138 11.1198C16.463 10.9179 17.4984 9.75519 17.5 8.34919C17.5017 6.94485 16.4695 5.77889 15.1211 5.57294"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.04466 12.4784C9.17116 13.4019 9.41599 15.2019 9.44766 15.652C9.50274 16.3071 9.15491 16.8601 8.59466 17.0733C8.02626 17.2939 7.29976 17.0968 6.93651 16.5836C6.76299 16.3549 6.64461 16.0784 6.55785 15.802C6.16298 14.5468 5.63432 12.7549 5.24756 11.4681"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.14809 5.0293L6.14404 8.13233"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BroadcastIcon;
